
import { Component, Mixins, Prop, PropSync } from 'vue-property-decorator';
import { VuetifyMixin } from '@/mixins/VuetifyMixin';
import { ConfirmationDialog } from "@/components/ui/ConfirmationDialog.vue";
import { mdiUpload, mdiYoutube } from '@mdi/js';
import SectionHeading from "@/components/ui/SectionHeading.vue";
import Alert from "@/components/ui/Alert.vue";
import { filesize } from "@/pipes";
import { getMediumDateString } from "@/helpers";
import ProgressBar from "@/components/charts/ProgressBar.vue";
import { UpgradeNowMixin } from '@/mixins/UpgradeNowMixin';

export enum VideoUploadDialogVariant {
	BASIC,
	SHOWCASE,
	ELITE
}

@Component({
	components: {
		ConfirmationDialog,
		SectionHeading,
		Alert,
		ProgressBar
	}
})
export class VideoUploadDialog extends Mixins(VuetifyMixin, UpgradeNowMixin){
	@PropSync('show',{ default: false, type: Boolean }) Show: boolean;
	@Prop({ default: false, type: Boolean }) dark: boolean;

	@Prop({ default: VideoUploadDialogVariant.BASIC }) variant: VideoUploadDialogVariant;

	@PropSync('file', { default: null, type: File }) VideoFile: File | null;
	@Prop({ default: null, type: Number }) uploadProgress: number | null;
	@Prop({ default: 0, type: Number }) videoHoursUsed: number;
	@Prop({ default: 0, type: Number }) maxVideoHours: number;

	@Prop({ default: 0, type: Number }) youtubeUsed: number;
	@Prop({ default: 1, type: Number }) maxYoutubeVideos: number;
	@PropSync('youtubeUrl', { default: '', type: String }) YoutubeUrl: string;

	eagerYoutubeUrl = ''

	mdiUpload = mdiUpload;
	mdiYoutube = mdiYoutube;
	filesize = filesize
	getMediumDateString = getMediumDateString;

	fileThumnail = '';
	test = ''

	$refs: {
		fileInput: HTMLInputElement
		thumbnailVid: HTMLSourceElement
	}

	get IsBasic(): boolean {
		return this.variant === VideoUploadDialogVariant.BASIC;
	}
	get IsShowcase(): boolean {
		return this.variant === VideoUploadDialogVariant.SHOWCASE;
	}
	get IsElite(): boolean {
		return this.variant === VideoUploadDialogVariant.ELITE;
	}
	get PlanText(): string {
		return this.IsBasic ? 
			'Your Basic Subscription allows you to upload 1 video from YouTube.' :
			'Your Showcase plan allows you to directly upload 5 hours of video from your device and add 3 YouTube video links.' 
	}

	getPercentColor(value: number): string {
		if (value < 50) {
			return 'baColorGreen1'
		}
		else if (value < 100) {
			return 'yellow'
		}
		else {
			return 'baColorRed'
		}
	}

	get YoutubeFullPercent(): number{
		return this.youtubeUsed  / this.maxYoutubeVideos * 100
	}
	get YoutubeProgressBarColor(): string {
		return this.getPercentColor(this.YoutubeFullPercent)
	}

	async detectVideoFiles($event: Event): Promise<void> {
		this.VideoFile = ($event.target as HTMLInputElement).files[0]
	}
	async addYoutube(validate: () => Promise<boolean>): Promise<void> {
		const valid = await validate();
		
		if (valid && this.eagerYoutubeUrl.trim().length > 0) {
			this.YoutubeUrl = this.eagerYoutubeUrl.trim();
			this.$emit('addyoutube', this.eagerYoutubeUrl);
		}
	}

	get VideoHoursPercentage(): number {
		return Math.ceil(this.videoHoursUsed * 100 / this.maxVideoHours)
	}
	get VideoHoursColor(): string {
		return this.getPercentColor(this.VideoHoursPercentage);
	}

}

export default VideoUploadDialog;
